// Values from server/macro/models/enums/pop_data_type.py
export const POP_DATA_TYPE_OPTIONS = [
  { value: "MoM%", label: "MoM%" },
  { value: "QoQ%", label: "QoQ%" },
  { value: "YoY%", label: "YoY%" },
  { value: "HoH%", label: "HoH%" },
  { value: "Net Monthly Change", label: "Net Monthly Change" },
  { value: "Net Quarterly Change", label: "Net Quarterly Change" },
  { value: "Net Yearly Change", label: "Net Yearly Change" },
  { value: "Net Half Year Change", label: "Net Half Year Change" },
  { value: "bpDoD", label: "bpDoD" },
]

// Values from server/macro/models/enums/survey_data_type.py
export const SURVEY_DATA_TYPE_OPTIONS = [
  { value: "% Balance/Diffusion Index NSA", label: "% Balance/Diffusion Index NSA" },
  { value: "% Balance/Diffusion Index SA", label: "% Balance/Diffusion Index SA" },
]

export const SEASONALITY_AND_TRANSFORMATION_OPTIONS = [
  ...POP_DATA_TYPE_OPTIONS,
  ...SURVEY_DATA_TYPE_OPTIONS,
]

